import React from 'react';
import { Table, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import EndOfStayActionBadge from './EndOfStayActionBadge';
import OperationsEmptyState from './OperationsEmptyState';
import {
    formatReferenceDate,
    computeEffectiveTripEndDate,
    formatEffectiveEndOffset,
} from '../utils/dateHelpers';

const EndOfStayTable = ({ items = [], loading = false, compact = false, sectionKey = null }) => {
    const showEffectiveEnd = sectionKey === 'flower';
    if (loading) {
        return (
            <div className="text-center py-4">
                <Spinner animation="border" size="sm" role="status" />
                <span className="ms-2">Chargement…</span>
            </div>
        );
    }

    if (!items.length) {
        return (
            <OperationsEmptyState
                message="Aucune police fin de séjour pour cette plage"
                compact={compact}
            />
        );
    }

    return (
        <div className="table-responsive admin-ds-table-wrapper">
            <Table hover className="admin-ds-data-table mb-0" size={compact ? 'sm' : undefined}>
                <thead>
                    <tr>
                        <th scope="col">Policy</th>
                        <th scope="col">Réservation</th>
                        <th scope="col">Partenaire</th>
                        <th scope="col">Client</th>
                        <th scope="col">E-mail</th>
                        <th scope="col">Activité</th>
                        <th scope="col">Fin séjour</th>
                        {showEffectiveEnd && <th scope="col">Fin effective</th>}
                        <th scope="col">Jour opération</th>
                        <th scope="col" className="text-center">Sinistres</th>
                        <th scope="col">Action prévue</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((row) => (
                        <tr key={`${row.policy_id}-${row.new_trip_end_date}-${row.end_of_stay_email_action}`}>
                            <td>
                                {row.policy_id ? (
                                    <Link to={`/admin/trips/policies/${row.policy_id}`}>
                                        {row.policy_code || '—'}
                                    </Link>
                                ) : (
                                    row.policy_code || '—'
                                )}
                            </td>
                            <td>{row.reservation_number || '—'}</td>
                            <td>{row.partner_name || '—'}</td>
                            <td>{row.client_name || '—'}</td>
                            <td>
                                {row.client_email ? (
                                    <a href={`mailto:${row.client_email}`}>{row.client_email}</a>
                                ) : '—'}
                            </td>
                            <td>{row.activity_name || '—'}</td>
                            <td>{formatReferenceDate(row.new_trip_end_date)}</td>
                            {showEffectiveEnd && (
                                <td>
                                    {formatReferenceDate(
                                        computeEffectiveTripEndDate(
                                            row.new_trip_end_date,
                                            row.effective_end_date
                                        )
                                    )}
                                    {formatEffectiveEndOffset(row.effective_end_date) && (
                                        <small className="text-muted ms-1">
                                            ({formatEffectiveEndOffset(row.effective_end_date)})
                                        </small>
                                    )}
                                </td>
                            )}
                            <td>{formatReferenceDate(row.operation_date)}</td>
                            <td className="text-center">{row.claim_count ?? 0}</td>
                            <td>
                                <EndOfStayActionBadge action={row.end_of_stay_email_action} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default EndOfStayTable;
